export var regions;
(function (regions) {
    regions["eu_west_1"] = "eu-west-1";
    regions["eu_west_2"] = "eu-west-2";
    regions["eu_west_3"] = "eu-west-3";
    regions["eu_central_1"] = "eu-central-1";
    regions["us_east_1"] = "us-east-1";
    regions["us_east_2"] = "us-east-2";
    regions["us_west_1"] = "us-west-1";
    regions["us_west_2"] = "us-west-2";
    regions["ca_central_1"] = "ca-central-1";
    regions["global"] = "global";
})(regions || (regions = {}));
;
